import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiFormReportListComponent } from './fi-form-report-list/fi-form-report-list.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { ItemsListModule } from '@fi-app/components/items-list/items-list.module';
import { FiSideListNewModule } from '@fi-app/utilities/side-list-new/side-list-new.module';
import { UIRouterModule } from '@uirouter/angular';
import { FormReportStates } from '@fi-app/fi-form/fi-form-report/fi-form-report-states';
import { FiFormReportContainerComponent } from './fi-form-report-container.component';
import { ButtonBackModule } from '@fi-app/utilities/button-back/button-back.module';
import { FiPrintDownloadModule } from '@fi-shared/fi-print-download/fi-print-download.module';
import { MatMenuModule } from '@angular/material/menu';
import { FiFormReportComponent } from '@fi-app/fi-form/fi-form-report/fi-form-report.component';
import { FiFormReportActivityComponent } from '@fi-app/fi-form/fi-form-report/fi-form-report-activity-list/fi-form-report-activity-list.component';
import { FiFormReportActivityUserReportComponent } from '@fi-app/fi-form/fi-form-report/fi-form-report-activity-list/fi-form-report-activity-user-report/fi-form-report-activity-user-report.component';
import { FiFormReportActiveColleaguesListComponent } from '@fi-app/fi-form/fi-form-report/fi-form-report-active-colleagues-list/fi-form-report-active-colleagues-list.component';
import { FiFormReportInactiveColleaguesListComponent } from '@fi-app/fi-form/fi-form-report/fi-form-report-inactive-colleagues-list/fi-form-report-inactive-colleagues-list.component';
import { FiFormReportQuestionComponent } from '@fi-app/fi-form/fi-form-report/fi-form-report-question/fi-form-report-question.component';
import { FiFormReportQuestionsDetailsComponent } from '@fi-app/fi-form/fi-form-report/fi-form-report-question/fi-form-report-question-details/fi-form-report-question-details.component';
import { FiFormReportQuestionDetailsAnswerComponent } from '@fi-app/fi-form/fi-form-report/fi-form-report-question/fi-form-report-question-details/fi-form-report-question-details-answer/fi-form-report-question-details-answer.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { MatIconModule } from '@angular/material/icon';
import { FiMediaViewerModule } from '@fi-shared/media-viewer/media-viewer.module';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { FiDatePickerModule } from '@fi-shared/fi-date-picker';
import { FiFormReportReminderDialogComponent } from '@fi-app/fi-form/fi-form-report/fi-form-report-inactive-colleagues-list/fi-form-report-reminder-dialog/fi-form-report-reminder-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';

@NgModule({
    imports: [
        CommonModule,
        ItemsListModule,
        FiSideListNewModule,
        FiAppTextSharedModule,
        ButtonBackModule,
        UIRouterModule.forChild(FormReportStates),
        FiPrintDownloadModule,
        MatMenuModule,
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatRadioModule,
        MatListModule,
        MatDialogModule,
        FormsModule,
        CommonModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        FiLoadingModule,
        FiAppTextSharedModule,
        InfoIconModule,
        MatIconModule,
        ItemsListModule,
        FiMediaViewerModule,
        FiDatePickerModule,
        FiAttachmentsModule,
        FiFormatDateModule,
        FiItemsListModule,
        FiPageHeaderModule,
        FiLocalSearch2Module,
        FiWrapperTableModule,
        FiWhenScrolledModule,
    ],
    declarations: [
        FiFormReportListComponent,
        FiFormReportContainerComponent,
        FiFormReportComponent,
        FiFormReportActivityComponent,
        FiFormReportActivityUserReportComponent,
        FiFormReportActiveColleaguesListComponent,
        FiFormReportInactiveColleaguesListComponent,
        FiFormReportQuestionComponent,
        FiFormReportQuestionsDetailsComponent,
        FiFormReportQuestionDetailsAnswerComponent,
        FiFormReportReminderDialogComponent,
    ],
})
export class FiFormReportModule {}
